import React from 'react'
import { ActivityFeed } from './ActivityFeed'
import '../RightBar.scss'

export const FeedPage = () => {
    return (
        <div className='feed-page'>
            <ActivityFeed fullScreen={true} />
        </div>
    )
}
